import { render, staticRenderFns } from "./PapercleanDocumentiMobileListComponent.vue?vue&type=template&id=91cffe1e"
import script from "./PapercleanDocumentiMobileListComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanDocumentiMobileListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports